import {
  Button,
  Col,
  Modal,
  Table,
  Typography,
} from "antd";
import React, { useEffect, useMemo, useRef, useState } from "react";
import "./CustomerReferral.css";
import CustomSelect from "../../../components/SelectableDropdown/CustomSelect/CustomSelect";
import SearchInput from "../../../components/Input/SearchInputs/SearchInput";
import DateRangePicker from "../../../components/DateRangePicker/DateRangePicker";
import dayjs from "dayjs";
import CustomTableWithPagination from "../../../components/CustomTableWithPagination/CustomTableWithPagination";

import { useLazyGetReferralSummaryReportQuery } from "../../../apis/reports";
import { dateFormat } from "../../../commonFuntions/CommonUtilFunctions";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import NoDataFound from "../../../components/EmptyTable/NoDataFound";
const { Text } = Typography;

const dateOptions = [
  {
    key: 1,
    value: "Today",
    label: "Today",
  },
  {
    key: 2,
    value: "Yesterday",
    label: "Yesterday",
  },
  {
    key: 3,
    value: "last_7_day",
    label: "Last 7 day",
  },
  {
    key: 4,
    value: "last_30_day",
    label: "Last 30 day",
  },
  {
    key: 5,
    value: "last_60_day",
    label: "Last 60 day",
  },
  {
    key: 6,
    value: "Custom",
    label: "Custom",
  },
  {
    key: 7,
    value: "clear_date",
    label: <Col style={{ color: "#006644", fontWeight: 500 }}>Clear Date</Col>,
  },
];
const CustomerReferral = () => {
  const [dateFilter, setDateFilter] = useState();
  const [searchedValue, setSearchedValue] = useState({});
  const [selectedSummary, setSelectedSummary] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [appliedDateParams, setAppliedDateParams] = useState({});
  const [
    ,// dateSearch
    // setDateSearch,
  ] = useState({
    start_date: "",
    end_date: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const detailsItemsPerPage = 30;
  const hasFetchedInitial = useRef(false);

  const [getReferralSummaryReportApi, { data: summaryResponse, isFetching: isSummaryFetching }] =
    useLazyGetReferralSummaryReportQuery();

  useEffect(() => {
    if (hasFetchedInitial.current) return;
    hasFetchedInitial.current = true;
    getReferralSummaryReportApi({ page: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearchApi = async (params = {}) => {
    const searchValue = params?.search;
    const query = {
      page: 1,
      ...appliedDateParams,
      ...(searchValue && { search: searchValue }),
    };
    await getReferralSummaryReportApi(query);
  };

  const handleSearchedValue = (params) => {
    setSearchedValue(params || {});
    setCurrentPage(1);
  };

  const handleViewDetails = (record) => {
    setSelectedSummary(record);
    setIsDetailsModalOpen(true);
    setCurrentPage(1);
  };

  const handleCloseDetailsModal = () => {
    setIsDetailsModalOpen(false);
  };

  const handlePageChange = (currPage) => {
    setCurrentPage(currPage);
  };
  const renderDateValue = (value) => (value ? dateFormat(value) : "-");
  const summaryData = useMemo(
    () => summaryResponse?.data?.summary || [],
    [summaryResponse?.data?.summary]
  );
  const detailData = useMemo(() => {
    const allResults = summaryResponse?.data?.results || [];
    if (!selectedSummary) return [];

    return allResults.filter(
      (item) =>
        item?.inviter_id === selectedSummary?.inviter_id &&
        item?.referral_code === selectedSummary?.referral_code
    );
  }, [summaryResponse?.data?.results, selectedSummary]);

  const paginatedDetailData = useMemo(() => {
    const start = (currentPage - 1) * detailsItemsPerPage;
    const end = start + detailsItemsPerPage;
    return detailData.slice(start, end);
  }, [currentPage, detailData]);
  const summaryColumns = [
    
    {
      title: "Action",
      key: "action",
      width: 120,
      fixed: "right",
      render: (_, record) => {
    
        return (
          <Button type="link" onClick={() => handleViewDetails(record)}>
            View
          </Button>
        );
      },
    },
    {
      title: "Inviter name",
      dataIndex: "inviter_name",
      key: "inviter_name",
      width: 180,
      render: (value) => <Text >{value || "-"}</Text>,
    },
    {
      title: "Inviter phone",
      dataIndex: "inviter_phone_number",
      key: "inviter_phone_number",
      width: 160,
      render: (value) => <Text >{value || "-"}</Text>,
    },
    {
      title: "Referral code",
      dataIndex: "referral_code",
      key: "referral_code",
      width: 170,
      render: (value) => <Text >{value || "-"}</Text>,
    },
    {
      title: "Invited",
      dataIndex: "invited_count",
      key: "invited_count",
      width: 110,
      render: (value) => <Text >{value ?? 0}</Text>,
    },
    {
      title: "Ordered",
      dataIndex: "ordered_count",
      key: "ordered_count",
      width: 110,
      render: (value) => <Text >{value ?? 0}</Text>,
    },
    {
      title: "Not ordered",
      dataIndex: "not_ordered_count",
      key: "not_ordered_count",
      width: 130,
      render: (value) => <Text >{value ?? 0}</Text>,
    },
    {
      title: "Rewarded",
      dataIndex: "rewarded_count",
      key: "rewarded_count",
      width: 110,
      render: (value) => <Text >{value ?? 0}</Text>,
    },
    {
      title: "Inviter reward",
      dataIndex: "inviter_reward_amount",
      key: "inviter_reward_amount",
      width: 140,
      render: (value) => <Text >{value ?? 0}</Text>,
    },
    {
      title: "Invitee reward",
      dataIndex: "invitee_reward_amount",
      key: "invitee_reward_amount",
      width: 140,
      render: (value) => <Text >{value ?? 0}</Text>,
    },
    {
      title: "Wallet balance",
      dataIndex: "wallet_balance",
      key: "wallet_balance",
      width: 140,
      render: (value) => <Text >{value ?? 0}</Text>,
    },
    
  ];
  const columns = [
    // {
    //   title: "Invite id",
    //   dataIndex: "invite_id",
    //   key: "invite_id",
    //   fixed: "left",
    //   width: "120px",
    //   render: (params) => {
    //     return (
    //       <Text className="wallet-bank-styledText" style={{ fontWeight: 500 }}>
    //         {params}
    //       </Text>
    //     );
    //   },
    // },
    {
      title: "Status",
      dataIndex: "rewarded",
      key: "status",
      width: "150px",
      render: (params, record) => {
        const statusText = params ? "Rewarded" : record?.ordered ? "Ordered" : "Invited";
        return <Text>{statusText}</Text>;
      },
    },
    {
      title: "Referral code",
      dataIndex: "referral_code",
      key: "referral_code",
      width: "180px",
      render: (params) => {
        return <Text>{params || "-"}</Text>;
      },
    },
   
    {
      title: "Inviter name",
      dataIndex: "inviter_name",
      key: "inviter_name",
      width: "200px",
      render: (params) => {
        return <Text>{params || "-"}</Text>;
      },
    },
    {
      title: "Inviter phone",
      dataIndex: "inviter_phone_number",
      key: "inviter_phone_number",
      width: "170px",
      render: (params) => {
        return <Text>{params || "-"}</Text>;
      },
    },
    
    {
      title: "Invitee name",
      dataIndex: "invitee_name",
      key: "invitee_name",
      width: "200px",
      render: (params) => {
        return <Text>{params || "-"}</Text>;
      },
    },
    {
      title: "Invitee phone",
      dataIndex: "invitee_phone_number",
      key: "invitee_phone_number",
      width: "170px",
      render: (params) => {
        return <Text>{params || "-"}</Text>;
      },
    },
    {
      title: "Created at",
      dataIndex: "created_at",
      key: "created_at",
      width: "180px",
      render: (params) => {
        return (
          <Text>{renderDateValue(params)}</Text>
        );
      },
    },
   
    {
      title: "First order no",
      dataIndex: "first_order_number",
      key: "first_order_number",
      width: "180px",
      render: (params) => {
        return <Text>{params || "-"}</Text>;
      },
    },
    {
      title: "First order at",
      dataIndex: "first_order_at",
      key: "first_order_at",
      width: "180px",
      render: (params) => {
        return (
          <Text>{renderDateValue(params)}</Text>
        );
      },
    },
    {
      title: "Reward posted at",
      dataIndex: "reward_posted_at",
      key: "reward_posted_at",
      width: "180px",
      render: (params) => {
        return (
          <Text>{renderDateValue(params)}</Text>
        );
      },
    },
    {
      title: "Inviter reward",
      dataIndex: "inviter_reward_amount",
      key: "inviter_reward_amount",
      width: "150px",
      render: (params) => {
        return <Text>{params ?? 0}</Text>;
      },
    },
    {
      title: "Invitee reward",
      dataIndex: "invitee_reward_amount",
      key: "invitee_reward_amount",
      width: "150px",
      render: (params) => {
        return <Text>{params ?? 0}</Text>;
      },
    },
    {
      title: "Inviter remaining",
      dataIndex: "inviter_reward_remaining",
      key: "inviter_reward_remaining",
      width: "170px",
      render: (params) => {
        return <Text>{params ?? 0}</Text>;
      },
    },
    {
      title: "Invitee remaining",
      dataIndex: "invitee_reward_remaining",
      key: "invitee_reward_remaining",
      width: "170px",
      render: (params) => {
        return <Text>{params ?? 0}</Text>;
      },
    },
    {
      title: "Ordered",
      dataIndex: "ordered",
      key: "ordered",
      width: "120px",
      render: (params) => {
        return <Text>{params ? "Yes" : "No"}</Text>;
      },
    },
    {
      title: "Rewarded",
      dataIndex: "rewarded",
      key: "rewarded",
      width: "120px",
      render: (params) => {
        return <Text>{params ? "Yes" : "No"}</Text>;
      },
    },
    
    
  ];
  // const handleChangeRangePicker = (dates, dateStrings) => {
  //   if (dates && dates.length === 2) {
  //     const startDateFormatted = dates[0].format("YYYY-MM-DD");
  //     const endDateFormatted = dates[1].format("YYYY-MM-DD");
  //     setDateSearch({
  //       start_date: startDateFormatted,
  //       end_date: endDateFormatted,
  //       // bmp_id: bmp_id,
  //     });
  //   }
  // };

  const handleDateChange = (value) => {
    let formattedDate = null;

    switch (value) {
      case "Today":
        formattedDate = dayjs().format("YYYY-MM-DD");
        break;
      case "Yesterday":
        formattedDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
        break;
      case "last_7_day":
        formattedDate = dayjs().subtract(6, "day").format("YYYY-MM-DD");
        break;
      case "last_30_day":
        formattedDate = dayjs().subtract(29, "day").format("YYYY-MM-DD");
        break;
      case "last_60_day":
        formattedDate = dayjs().subtract(59, "day").format("YYYY-MM-DD");
        break;
      case "Custom":
        formattedDate = "Custom";
        break;
      default:
        break;
    }

    const currentDate = dayjs().format("YYYY-MM-DD");
      if (value !== "Custom" && value !== null) {
        let nextDateParams = {};
        if (value === "clear_date") {
          nextDateParams = {};
        } else {
        nextDateParams = {
          start_date: formattedDate,
          end_date: currentDate,
        };
      }
      const query = {
        page: 1,
        ...(searchedValue?.search && { search: searchedValue?.search }),
        ...nextDateParams,
      };
      setAppliedDateParams(nextDateParams);
      getReferralSummaryReportApi(query);
      setCurrentPage(1);
    }
    setDateFilter(value);
  };

  const handleChangeRangePicker = (dates) => {
    if (dates && dates.length === 2) {
      const startDateFormatted = dates[0].format("YYYY-MM-DD");
      const endDateFormatted = dates[1].format("YYYY-MM-DD");
      const nextDateParams = {
        start_date: startDateFormatted,
        end_date: endDateFormatted,
      };
      const query = {
        page: 1,
        ...(searchedValue?.search && { search: searchedValue?.search }),
        ...nextDateParams,
      };
      setAppliedDateParams(nextDateParams);
      setCurrentPage(1);
      getReferralSummaryReportApi(query);
    }
  };

  // const handleDateChange = (value) => {
  //   let formattedDate = null;

  //   switch (value) {
  //     case "Today":
  //       formattedDate = dayjs().format("YYYY-MM-DD");
  //       break;
  //     case "Yesterday":
  //       formattedDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
  //       break;
  //     case "last_7_day":
  //       formattedDate = dayjs().subtract(6, "day").format("YYYY-MM-DD");
  //       break;
  //     case "last_30_day":
  //       formattedDate = dayjs().subtract(29, "day").format("YYYY-MM-DD");
  //       break;
  //     case "last_60_day":
  //       formattedDate = dayjs().subtract(59, "day").format("YYYY-MM-DD");
  //       break;
  //     case "Custom":
  //       formattedDate = "Custom";
  //       break;
  //     default:
  //       break;
  //   }

  //   const currentDate = dayjs().format("YYYY-MM-DD");
  //   setDateSearch({
  //     start_date: formattedDate,
  //     end_date: currentDate,
  //     //   bmp_id: bmp_id,
  //   });
  //   setDateFilter(value);
  // };
  // const handleSearchOnDate = () => {
  //   // getSettlementByIDAPI(dateSearch);
  // };
  return (
    <Col className="walletBank-container">
      <Text className="customer_title">Customer Referrals</Text>
      <Col style={{ display: "flex", gap: "1rem" }}>
        <SearchInput
          size={"large"}
          placeholder={"Search by customer name, mobile no, email"}
          getLibraryApi={handleSearchApi}
          handleSearchedValue={handleSearchedValue}
          width={"400px"}
          isLoading={isSummaryFetching}
        />
        <Col className="action-sub-container">
          <CustomSelect
            placeholder={"Date"}
            width={"150px"}
            options={dateOptions}
            handleChange={handleDateChange}
            value={dateFilter}
          />
          {dateFilter === "Custom" && (
            <DateRangePicker
              onChange={handleChangeRangePicker}
              format={"DD-MMM-YYYY"}
            />
          )}
          {/* <Button
            size="large"
            style={{
              backgroundColor: "#0354a3",
              color: "#fff",
              fontWeight: 500,
              height: "48px",
            }}
            onClick={() => handleSearchOnDate()}
          >
            Search
          </Button> */}
        </Col>
      </Col>
      <Col className="customer-referral-summary-wrapper">
        {/* <Col className="customer-referral-summary-header">
          <Text className="customer-referral-summary-title">Referral Summary</Text>
          <Text className="customer-referral-summary-subtitle">
            {`${summaryData.length} inviters`}
          </Text>
        </Col> */}
        <Col className="customer-referral-summary-table-wrap">
          <Table
           
            rowKey={(record, index) =>
              `${record?.inviter_id || "inviter"}-${record?.referral_code || "code"}-${index}`
            }
            dataSource={summaryData}
            columns={summaryColumns}
            pagination={false}
            scroll={{ x: 1400 }}
            locale={{
              emptyText: isSummaryFetching ? (
                <TableSkeleton length={4} />
              ) : (
                <NoDataFound text={"No summary found!"} />
              ),
            }}
          />
        </Col>
      </Col>
      <Modal
        title={`Referral Details${selectedSummary?.inviter_name ? ` - ${selectedSummary?.inviter_name}` : ""}`}
        open={isDetailsModalOpen}
        onCancel={handleCloseDetailsModal}
        footer={null}
        className="customer-referral-details-modal"
        width={800}
        centered
       
        destroyOnClose
      >
         <Col className="customer-referral-modal-container">
        <CustomTableWithPagination
          className="order-list-table"
          tableDataSource={paginatedDetailData}
          tableColumns={columns}
          locale={{
            emptyText: isSummaryFetching ? (
              <TableSkeleton length={10} />
            ) : (
              <NoDataFound text={"No transaction found!"} />
            ),
          }}
          isLoading={isSummaryFetching}
          scroll={{ x: 1400, y: 240 }}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          itemsPerPage={detailsItemsPerPage}
          totalEntries={!isSummaryFetching ? detailData.length : 0}
        />
        </Col>
      </Modal>
    </Col>
  );
};

export default CustomerReferral;
